import {makeStyles} from "@material-ui/core/styles";
import {topHeight} from "../../../../stores/NavigateStore";

export const  useStyles = makeStyles((theme) => ({
    root:{
        width: '100%',
    },
    emptyBox:{
        width: '100%',
        height: `calc(100vh - ${topHeight}px - 36px - 20px - 24px - 24px)`,
        display:'flex',
        alignItems: 'center',
        justifyContent: 'center',
        '& p':{
            fontSize: '1.375rem',
            color: '#87888d',
            fontWeight:400,
            textAlign: 'center',
            lineHeight: '30.36px'
        }
    },
    topBox: {
        display: 'flex',
        justifyContent: 'center',
        alignItems: 'flex-start',
        background: '#fff',
        borderRadius: 8,
        height: 170,
        marginBottom: 20,
        paddingTop: 35,
        '& .Mui-disabled': {
            '& .MuiStepLabel-iconContainer': {
                border: '1px solid #e5e5e5',
                color: '#e5e5e5',
                background: '#fff',
            }
        },
        '& .MuiStepIcon-root': {
            width: 40,
            height: 40,
        },
        '& .MuiStepConnector-alternativeLabel': {
            top: 20,
            left: 'calc(-50% + 30px)',
            right: 'calc(50% + 30px)',
        },
        '& .MuiStepLabel-iconContainer': {
            border: '1px solid #5579f0',
            width: 40,
            height: 40,
            borderRadius: '100%',
            color: '#fff',
            background: '#5579f0',
            fontSize: '1.5rem',
            fontWeight: 'bold',
            textAlign: 'center',
            display: 'inline-block',
            lineHeight: '38px',
        },
        '& .MuiStep-completed': {
            '& .MuiStepLabel-iconContainer': {
                border: '1px solid #5579f0',
                color: '#5579f0',
                background: '#fff',
            }
        },
        '& .MuiStepConnector-active': {
            '& .MuiStepLabel-iconContainer': {
                border: '1px solid #fff',
            }
        },
        '& .MuiStepLabel-label': {
            fontSize: '1.125rem',
            letterSpacing: '-0.5px',
            color: '#87888d',
            marginTop: 9,
            wordBreak: 'break-word',
        },
        '& .MuiStepLabel-label.MuiStepLabel-completed': {
            color: '#10121c',
        },
        '& .MuiStepLabel-label.MuiStepLabel-active': {
            color: '#5579f0'
        },
    },
    activeStepIcon: {
        width: '75%',
        padding: 0,
        marginTop: 5,
        '& .MuiStepIcon-active': {
            color: '#5579f0',
        },
        '& .MuiStepIcon-completed': {
            border: '1px solid #5579f0',
            borderRadius: '100%',
            color: '#fff'
        },
        userDrag: 'none',
        userSelect: 'none',
        '@media all and (max-width: 1800px)': {
            width: '90%',
            // '& .MuiStep-horizontal:last-child': {
            //     '& .MuiStepConnector-alternativeLabel': {
            //         left: 'calc(-50% + 45px)',
            //         right: 'calc(50% + 30px)',
            //     }
            // },
        },
        '@media all and (max-width: 1450px)': {
            width: '90%',
            // '& .MuiStep-horizontal:last-child': {
            //     '& .MuiStepConnector-alternativeLabel': {
            //         left: 'calc(-50% + 70px) !important',
            //         right: 'calc(50% + 30px)',
            //     }
            // },
        },
    },
    boxWrap: {
        backgroundColor: '#fff',
        padding: 20,
        borderRadius: 8,
        height: 'calc(100vh - 350px)'
    },
    tabBox: {
        '& .MuiTabs-root':{
            minHeight: 40,
        },
        '& .MuiTab-root':{
            minWidth: 70,
        },
        '& .MuiTabs-flexContainer': {
            // width: 248,
            borderBottom: '1px solid #bbbbbb',
            borderRadius: 0,
            overflow: 'hidden'
        },
        '& button': {
            width: 70,
            minHeight: 40,
            height: 40,
            position: 'relative',
            fontSize: '1.063rem',
            fontWeight: 500,
            letterSpacing: '-0.5px',
            color:'#323232',
            boxSizing: 'border-box',
            padding:0,
        },
        '& button.Mui-selected': {
            fontWeight: 600,
            color: '#5579f0',
            opacity: 1,
            boxSizing: 'border-box',
            background: '#fff',
            borderRadius: 0
        },
        '& .MuiTabs-indicator':{
            height: 3,
            paddingBottom: 0,
            backgroundColor: '#5579f0'
        }
    },
    textBox: {
        '& .MuiBox-root': {
            padding: '10px 0px',
        },
        '& .MuiFormControl-root': {
            width: '100%',

            '& .MuiInputBase-root': {
                borderRadius: 8,
                height: 150,
            }
        }
    },
    textBoxQuiz: {
        '& .MuiBox-root': {
            padding: '10px 0px',
        },
        '& .MuiFormControl-root': {
            width: '100%',
        },
        '& .MuiOutlinedInput-input': {
            padding: '10px 14px',
        }
    },
    textBoxTranslation: {
        '& .MuiFormControl-root': {
            width: '100%',

            '& .MuiInputBase-root': {
                borderRadius: 8,
                height: 110,
            }
        }
    },
    buttonStyle: {
        display: 'flex',
        justifyContent: 'right',
        '& .MuiButtonBase-root': {
            background: '#f27c57',
            color: '#fff',
            minWidth: 82,
            height: 34,
            '& .MuiTypography-root': {
                fontSize: '0.875rem',
                fontWeight: 'bold',
            }
        }
    },
    buttonGroup: {
        marginTop: 10,
    },
    listButtonStyle: {
        '& .MuiButtonBase-root': {
            '&:hover': {
                background: 'transparent'
            },
        },
        '& .MuiTypography-root': {
            marginLeft: 5,
            fontSize: '1rem',
            fontWeight: 'bold',
            letterSpacing: '-0.62px',
            color: '#10121c',
        }
    },
    buttonStyle2Active: {
        '& .MuiButtonBase-root': {
            border: '1px solid #5579f0',
            borderRadius: 4,
            background: '#fff',
            width: 100,
            height: 48,
            '& .MuiTypography-root': {
                fontSize: '1.125rem',
                fontWeight: 'bold',
                letterSpacing: '-0.51px',
                color: '#5579f0'
            }
        }
    },
    buttonStyle2: {
        '& .MuiButtonBase-root': {
            border: '1px solid #bcbcbc',
            borderRadius: 4,
            background: '#fff',
            width: 100,
            height: 48,
            '& .MuiTypography-root': {
                fontSize: '1.125rem',
                fontWeight: 'bold',
                letterSpacing: '-0.51px',
                color: '#bcbcbc'
            }
        }
    },
    buttonStyle3: {
        '& .MuiButtonBase-root': {
            border: '0px solid #5579f0',
            background: 'rgba(16, 18, 28, 0.3)',
            marginLeft: 16,
            width: 100,
            height: 48,
            '& .MuiTypography-root': {
                fontSize: '1.125rem',
                fontWeight: 'bold',
                letterSpacing: '-0.51px',
                color: '#fff'
            }
        }
    },
    buttonStyle3Active: {
        '& .MuiButtonBase-root': {
            border: '0px solid #5579f0',
            background: '#5579f0',
            '& .MuiTypography-root': {
                fontSize: '1.125rem',
                fontWeight: 'bold',
                letterSpacing: '-0.51px',
                color: '#fff'
            }
        }
    },
    backButton: {
        background: '#fff',
        boxShadow: 'none',
        padding: 0,
        '&:hover': {
            background: 'transparent',
            boxShadow: 'none',
        }
    },
    boxWrapTranslation: {
        // height: 'calc(100vh - 740px)'
        height: '100%',
    },
    boxBottomTranslation: {
        backgroundColor: '#fff',
        padding: 20,
        borderRadius: 8,
        marginTop : 20,
        height: 'calc(100vh - 605px)',
        overflowX: 'auto',
        '& .MuiFormControl-root': {
            width: '100%',
            '& .MuiInputBase-root': {
                height: 110,
            },
        },
        '& div:nth-child(1)': {
            marginTop: 0,
        }
    },
    translationTitle: {
        marginTop: 33,
        marginBottom: 10,
        '& .MuiTypography-root': {
            fontSize: '0.938rem',
            fontWeight: 'bold',
            letterSpacing: '-0.5px',
            color: '#10121c',
        },
        '& .MuiButtonBase-root': {
            minWidth: 'auto',
            padding: 0,
            '&:hover': {
                background: 'transparent'
            },
        }
    },
    langText: {
        '&.MuiTypography-root': {
            fontSize: '0.938rem',
            fontWeight: 'bold',
            letterSpacing: '-0.5px',
            color: '#10121c',
            marginRight: 10,
        },
    },
    swichStyle: {
        '&.MuiSwitch-root': {
            padding: '10px 10px',
        },
        '& .MuiSwitch-switchBase': {
            color: '#fff !important',
        },
        '& .MuiSwitch-thumb': {
            width: 14,
            height: 14,
        },
        '& .MuiButtonBase-root': {
            paddingTop: '12px',
            paddingLeft: '12px',
        },
        '& .MuiSwitch-track': {
            borderRadius: 10,
        },
        '& .MuiSwitch-colorSecondary.Mui-checked + .MuiSwitch-track': {
            background: '#5579f0',
            opacity: 1
        }
    },
    textQuizBox: {
        marginTop: 10,
        '& .MuiFormControl-root': {
            width: 240,
            height: 40,
            boxSizing: 'border-box',
            marginRight: 10,
        },
        '& .MuiOutlinedInput-root': {
            height: 40
        },
        '& .MuiButtonBase-root': {
            width: 70,
            height: 40,
            background: 'rgba(16, 18, 28, 0.3)',
            '& .MuiTypography-root': {
                fontSize: '1.125rem',
                color: 'rgba(255, 255, 255, 0.7)',
                fontWeight: 'bold'
            }
        },
        '& .MuiOutlinedInput-input': {
            padding: '9px 10px',
        }
    },
    active: {
        '&.MuiButtonBase-root': {
            width: 70,
            height: 40,
            background: '#f27c57',
            '& .MuiTypography-root': {
                fontSize: '1.125rem',
                color: '#fff',
                fontWeight: 'bold'
            }
        }
    },
    quizListBox: {
        marginTop: 20,
        '& > div': {
            width: 600,
        },
        '& > div:last-child': {
            width: 500,
        },
    },
    quizWord: {
        border: '1px solid #87888d',
        width: 160,
        height: 40,
        borderRadius: 4,
        '& .MuiTypography-root': {
            width: 110,
            textAlign: 'center',
            fontSize: '1.125rem',
            fontWeight: 'bold'
        }
    },
    quizVolume: {
        '&.MuiIconButton-root': {
            padding: 0,
            marginRight: 10,
            '&:hover': {
                background: 'transparent'
            }
        }
    },
    quizRefresh: {
        '&.MuiIconButton-root': {
            padding: 0,
            marginLeft: 10,
            '&:hover': {
                background: 'transparent'
            }
        }
    },
    loadingBox: {
        position: 'fixed',
        top: 0,
        left: 0,
        right: 0,
        bottom: 0,
        backgroundColor: 'rgba(255, 255, 255, 0.3)',
        zIndex: 1000,
        width: '100%',
        height: '100%',
        display: 'flex',
        flexDirection: 'column',
        alignItems: 'center',
        justifyContent: 'center',
        backdropFilter: 'blur(5px)'
    },
    loadingBoxTitle: {
        justifyContent: 'center',
        color: '#323232',
        fontSize: '1.725rem',
        fontWeight: '700',
        marginTop: '20px',
        marginBottom: '5px'
    },
    dot: {
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
        height: '17px',
        width: '17px',
        borderRadius: '50%',
        backgroundColor: '#5579F0',
        animation: '$dotAnimation 1s infinite',

        '&:nth-of-type(1)': {
            animationDelay: '0ms',
        },
        '&:nth-of-type(2)': {
            animationDelay: '250ms',
        },
        '&:nth-of-type(3)': {
            animationDelay: '500ms',
        },
    },
    '@keyframes dotAnimation': {
        '0%': {
            transform: 'scale(0.2)',
            opacity: 0.7,
        },
        '50%': {
            transform: 'scale(1)',
            opacity: 1,
        },
        '100%': {
            transform: 'scale(0.2)',
            opacity: 0.7,
        },
    },
    dotLoader: {
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
        width: '100%'
}

}));

